var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-card',{attrs:{"border-variant":"danger","header":_vm.$t('Cookies.header'),"header-bg-variant":"danger","header-text-variant":"white","align":"left"}},[_c('p',[_vm._v("\n          "+_vm._s(_vm.$t('Cookies.policyText'))+"\n        ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08504c3a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cookies.vue
// module id = null
// module chunks = 